// extracted by mini-css-extract-plugin
export default {"studyFile":"StudyFile_studyFile__WBNrf","close":"StudyFile_close__8w4d8","errorBlock":"StudyFile_errorBlock__p7p3k","pdf":"StudyFile_pdf__wKwGK"};